import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import IContactResolver from "@models/icontact-resolver.model";
import { ProjectService } from "@services/project.service";
import { Observable, of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ContactResolver implements Resolve<any> {
  selectedProject: any;
  selectedDevelopment: any;
  constructor(public projectsService: ProjectService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<IContactResolver> | Promise<IContactResolver> {
    this.selectedProject = '';
    this.selectedDevelopment = '';

    // const projectId = route.queryParams["EBuilderProjectId"];
    const projectId = route.params["itemId"];

    if (projectId) {
      this.selectedProject = projectId;
      this.selectedDevelopment =
        this.projectsService.getProjectById(projectId)?.developmentName ?? "";
    }

    return of({
      selectedProject: this.selectedProject,
      selectedDevelopment: this.selectedDevelopment,
    });
  }
}
